"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadUpadteGuard = exports.loadCreateGuard = exports.eventUpdateGuard = exports.eventGuard = exports.companyGuard = exports.userUpdateGuard = exports.userDeleteGuard = exports.userCreateGuard = exports.userReadGuard = exports.loggedIn = exports.adminOrOwnCompany = exports.disallow = exports.allowIf = exports.allow = void 0;
var sdk_1 = require("dollarscript/build/sdk");
exports.allow = { allow: true };
function allowIf(condition) {
    return sdk_1.$if(condition, exports.allow, exports.disallow);
}
exports.allowIf = allowIf;
exports.disallow = { allow: false };
exports.adminOrOwnCompany = sdk_1.$if(sdk_1.$eq(sdk_1.$ref('currentUser.role'), 'Admin'), exports.allow, {
    allow: true,
    constraint: {
        companyId: {
            type: 'eq',
            value: sdk_1.$ref('currentUser.companyId'),
        },
    },
});
exports.loggedIn = sdk_1.$neq(sdk_1.$ref('currentUser'), undefined);
exports.userReadGuard = sdk_1.$if(sdk_1.$eq(sdk_1.$ref('currentUser.role'), 'Admin'), exports.allow, sdk_1.$if(sdk_1.$eq(sdk_1.$ref('currentUser.role'), 'Dispatcher'), {
    allow: true,
    constraint: {
        companyId: { type: 'eq', value: sdk_1.$ref('currentUser.companyId') },
        role: { type: 'in', value: ['Driver', 'Dispatcher'] },
    },
}, sdk_1.$if(sdk_1.$in(sdk_1.$ref('currentUser.role'), ['CustomerService', 'Forwarder']), {
    allow: true,
    constraint: {
        companyId: { type: 'eq', value: sdk_1.$ref('currentUser.companyId') },
    },
}, { allow: true, constraint: { id: { type: 'eq', value: sdk_1.$ref('currentUser.id') } } })));
exports.userCreateGuard = sdk_1.$if(sdk_1.$eq(sdk_1.$ref('currentUser.role'), 'Admin'), {
    allow: true,
    constraint: {
        companyId: { type: 'eq', value: sdk_1.$ref('currentUser.companyId') },
    },
}, sdk_1.$if(sdk_1.$eq(sdk_1.$ref('currentUser.role'), 'Dispatcher'), {
    allow: true,
    constraint: {
        companyId: { type: 'eq', value: sdk_1.$ref('currentUser.companyId') },
        role: { type: 'eq', value: 'Driver' },
        idNumber: { type: 'neq', value: undefined },
        passportNumber: { type: 'neq', value: undefined },
        drivingLicenceNumber: { type: 'neq', value: undefined },
    },
}, exports.disallow));
exports.userDeleteGuard = sdk_1.$if(sdk_1.$eq(sdk_1.$ref('currentUser.role'), 'Admin'), exports.allow, sdk_1.$if(sdk_1.$eq(sdk_1.$ref('currentUser.role'), 'Dispatcher'), {
    allow: true,
    constraint: {
        companyId: { type: 'eq', value: sdk_1.$ref('currentUser.companyId') },
        role: { type: 'eq', value: 'Driver' },
    },
}, { allow: true, constraint: { id: { type: 'eq', value: sdk_1.$ref('currentUser.id') } } }));
exports.userUpdateGuard = sdk_1.$if(sdk_1.$eq(sdk_1.$ref('currentUser.role'), 'Admin'), exports.allow, sdk_1.$if(sdk_1.$eq(sdk_1.$ref('currentUser.role'), 'Dispatcher'), {
    allow: true,
    constraint: {
        companyId: { type: 'eq', value: sdk_1.$ref('currentUser.companyId') },
        role: { type: 'in', value: ['Driver', 'Dispatcher'] },
    },
}, {
    allow: true,
    constraint: {
        id: { type: 'eq', value: sdk_1.$ref('currentUser.id') },
        role: { type: 'eq', value: sdk_1.$ref('previousEntity.role') },
    },
}));
exports.companyGuard = sdk_1.$if(sdk_1.$eq(sdk_1.$ref('currentUser.role'), 'Admin'), exports.allow, sdk_1.$if(sdk_1.$in(sdk_1.$ref('currentUser.role'), ['CustomerService', 'Forwarder']), { allow: true, constraint: { admin: { type: 'eq', value: false } } }, exports.disallow));
exports.eventGuard = sdk_1.$if(sdk_1.$or(sdk_1.$eq(sdk_1.$ref('currentUser.companyId'), sdk_1.$ref('currentEntity.companyId')), sdk_1.$eq(sdk_1.$ref('currentEntity.companyId'), undefined)), {
    allow: true,
    constraint: {
        companyId: { type: 'eq', value: sdk_1.$ref('currentUser.companyId') },
        ownerId: { type: 'eq', value: sdk_1.$ref('currentUser.id') },
    },
}, exports.disallow);
exports.eventUpdateGuard = sdk_1.$if(sdk_1.$or(sdk_1.$eq(sdk_1.$ref('currentUser.companyId'), sdk_1.$ref('currentEntity.companyId')), sdk_1.$eq(sdk_1.$ref('currentEntity.companyId'), undefined)), {
    allow: true,
    constraint: {
        companyId: { type: 'eq', value: sdk_1.$ref('currentUser.companyId') },
        ownerId: { type: 'eq', value: sdk_1.$ref('previousEntity.ownerId') },
    },
}, exports.disallow);
var loadCreateConstraint = {
    companyId: { type: 'eq', value: sdk_1.$ref('currentUser.companyId') },
    emailSentDate: { type: 'eq', value: sdk_1.$ref('currentUser.emailSentDate') },
    ownerId: { type: 'eq', value: sdk_1.$ref('currentUser.id') },
    managerId: { type: 'eq', value: undefined },
    lateForLoading: { type: 'eq', value: undefined },
    ADR: { type: 'eq', value: false },
    lateForUnloading: { type: 'eq', value: undefined },
    status: { type: 'in', value: ['for-valuation', 'accepted'] },
};
exports.loadCreateGuard = sdk_1.$if(sdk_1.$and(sdk_1.$neq(sdk_1.$ref('currentUser.role'), 'Driver'), sdk_1.$neq(sdk_1.$ref('currentEntity.status', 'for-valuation'), 'for-valuation')), {
    allow: true,
    constraint: __assign(__assign({}, loadCreateConstraint), { inputPrice: { type: 'eq', value: undefined } }),
}, sdk_1.$if(sdk_1.$neq(sdk_1.$ref('currentUser.role'), 'Driver'), {
    allow: true,
    constraint: __assign(__assign({}, loadCreateConstraint), { valuationPrice: { type: 'eq', value: undefined } }),
}, exports.disallow));
var loadUpdateConstraint = {
    companyId: { type: 'eq', value: sdk_1.$ref('previousEntity.companyId') },
    ownerId: { type: 'eq', value: sdk_1.$ref('previousEntity.ownerId') },
    managerId: { type: 'eq', value: sdk_1.$ref('previousEntity.managerId') },
    lateForLoading: { type: 'eq', value: sdk_1.$ref('previousEntity.lateForLoading') },
    ADR: { type: 'eq', value: false },
    lateForUnloading: { type: 'eq', value: sdk_1.$ref('previousEntity.lateForUnloading') },
};
exports.loadUpadteGuard = sdk_1.$if(sdk_1.$and(sdk_1.$neq(sdk_1.$ref('currentUser.role'), 'Driver'), sdk_1.$neq(sdk_1.$ref('currentEntity.status', 'for-valuation'), 'for-valuation')), {
    allow: true,
    constraint: __assign(__assign({}, loadUpdateConstraint), { inputPrice: { type: 'eq', value: sdk_1.$ref('previousEntity.inputPrice') } }),
}, sdk_1.$if(sdk_1.$neq(sdk_1.$ref('currentUser.role'), 'Driver'), {
    allow: true,
    constraint: __assign(__assign({}, loadUpdateConstraint), { valuationPrice: { type: 'eq', value: sdk_1.$ref('previousEntity.valuationPrice') } }),
}, exports.disallow));
//# sourceMappingURL=guards.js.map